// extracted by mini-css-extract-plugin
module.exports = {"container-switcher":"ATnoConsentSwitcher_container-switcher__Kw1xH","containerSwitcher":"ATnoConsentSwitcher_container-switcher__Kw1xH"};